const MONTHS_SHORT: Record<string, string[]> = {
  ru: ["Янв", "Фев", "Мар", "Апр", "Май", "Июн", "Июл", "Авг", "Сен", "Окт", "Ноя", "Дек"],
  kk: ["Қаң", "Ақп", "Нау", "Сәу", "Мам", "Мау", "Шіл", "Там", "Қыр", "Қаз", "Қар", "Жел"],
  en: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
};

export function formatChartLabel(date: string, interval: "day" | "week" | "month" | "quarter" | "half_year" | "halfyear", locale: string): string {
  const months = MONTHS_SHORT[locale] || MONTHS_SHORT.ru;

  if (interval === "quarter") {
    return date.split("-")[1] || date;
  }

  if (interval === "half_year" || interval === "halfyear") {
    return date.split("-")[1] || date;
  }

  if (interval === "month") {
    const parts = date.split("-");
    const monthIdx = parseInt(parts[1], 10) - 1;
    return months[monthIdx] || date;
  }

  if (interval === "day" || interval === "week") {
    const parts = date.split("-");
    const day = parseInt(parts[2], 10);
    const monthIdx = parseInt(parts[1], 10) - 1;
    return `${day} ${months[monthIdx]}`;
  }

  return date;
}
